module.exports = __webpack_public_path__ + "media/images/favicons/favicon-32x32-3f3910cb06f6473cea7b3d2a1ddd932a.png";